<template>
  <div id="app">
    <!-- Show layout for authenticated users -->
    <BaseLayout v-if="authStore.isAuthenticated" />
    <!-- Show login/signup pages without layout -->
    <router-view v-else />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';
import BaseLayout from '@/components/BaseLayout.vue';

const authStore = useAuthStore();

// Initialize authentication state on app start
onMounted(() => {
  authStore.initializeAuth();
});
</script>
